<article *ngIf="videos.length > 0"
         class="w-full flex flex-column">
  <video #videoPlayer
         muted
         autoplay
         [src]="videos[currentVideoIndex].url"
         type="video/mp4"
         (ended)="onVideoEnded()"
         (click)="toggleVideo()"
         (loadeddata)="playVideo()"
         poster="https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/videos%2Fpeaton%2Ffondopaeton.png?alt=media&token=72612c93-87a3-4c31-a493-194c92c92c55">
    Tu navegador no soporta la etiqueta de video.
  </video>
</article>